export default __webpack_public_path__ + "locales/en/Translations.json?hash=cbe1d7ea92e9d33c8b7329b2b7353664";